import { OneBotBot } from '@satorijs/adapter-onebot'

export default OneBotBot
export * from '@satorijs/adapter-onebot'
